import { jsx } from "panel";
import { ConfirmEl } from "common/components/confirm";
import { SvgIconEl } from "common/components/svg-icon";
import { SelectEl } from "common/components/select";
import { ButtonSize } from "common/components/button/constants";
import { MappingType } from "./types";
export function template() {
  const boardEventsInfo = this.attr(`board-events-info`);
  return /* @__PURE__ */ jsx(ConfirmEl, {
    attrs: {
      open: true,
      closeable: true,
      "grow-to-content": true
    },
    on: {
      change: (ev) => {
        if (ev.detail.state === `closed`) {
          this.dispatchEvent(new CustomEvent(`close`));
        }
      },
      submit: () => {
        this.dispatchEvent(new CustomEvent(`submit`, { detail: { mapping: this.state.boardEventsMapping } }));
      }
    }
  }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-title"
  }, "Copy Board"), /* @__PURE__ */ jsx("div", {
    sel: ".section-title"
  }, "Determine your events & properties mapping for this Board."), /* @__PURE__ */ jsx("div", {
    sel: ".event-mapping-section"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".header-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".original-events"
  }, "Original Events"), /* @__PURE__ */ jsx("div", {
    sel: ".new-events"
  }, "New Events")), boardEventsInfo == null ? void 0 : boardEventsInfo.events.map((event) => /* @__PURE__ */ jsx("div", {
    sel: ".event-mapping-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".pre-selected-events"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".event-icon-wrapper"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".event-icon",
    attrs: { icon: `event` }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".pre-selected-events-text"
  }, event)), /* @__PURE__ */ jsx("div", {
    sel: ".arrow-icon-wrapper"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".arrow-icon",
    attrs: { icon: `arrow-right` }
  })), /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      sections: this.helpers.getDropdownSections(MappingType.EVENTS),
      size: ButtonSize.Large,
      "selected-option": this.state.boardEventsMapping.events[event]
    },
    sel: ".event-dropdown",
    on: {
      change: (ev) => this.helpers.handleDropdownSelected(MappingType.EVENTS, event, ev)
    }
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".header-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".original-events"
  }, "Original Properties"), /* @__PURE__ */ jsx("div", {
    sel: ".new-events"
  }, "New Properties")), boardEventsInfo == null ? void 0 : boardEventsInfo.properties.map((property) => /* @__PURE__ */ jsx("div", {
    sel: ".event-mapping-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".pre-selected-events"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".event-icon-wrapper"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".event-icon",
    attrs: { icon: `event-attribute` }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".pre-selected-events-text"
  }, property)), /* @__PURE__ */ jsx("div", {
    sel: ".arrow-icon-wrapper"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".arrow-icon",
    attrs: { icon: `arrow-right` }
  })), /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      sections: this.helpers.getDropdownSections(MappingType.PROPERTIES),
      size: ButtonSize.Large,
      "selected-option": this.state.boardEventsMapping.properties[property]
    },
    sel: ".event-dropdown",
    on: {
      change: (ev) => this.helpers.handleDropdownSelected(MappingType.PROPERTIES, property, ev)
    }
  }))))));
}
